module.exports = __webpack_public_path__ + "img/Icon-LN.c6ef8eda.svg";